import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { Gauge } from "lucide-react";

/**
 * Registrazione rapida di contaore e contachilometri.
 *
 * E' il gesto su cui si regge tutto il costo per ora e per chilometro: senza
 * almeno due letture quel numero non si puo' calcolare. Deve costare dieci
 * secondi, in piedi davanti alla macchina, dal telefono.
 */
export default function LetturaContatore({ eq, onSaved }) {
  const oggi = new Date().toISOString().substring(0, 10);
  const [aperto, setAperto] = useState(false);
  const [data, setData] = useState(oggi);
  const [ore, setOre] = useState("");
  const [km, setKm] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const chiudi = () => { setAperto(false); setOre(""); setKm(""); setNote(""); setData(oggi); };

  const salva = async () => {
    if (ore === "" && km === "") { toast.error("Scrivi le ore oppure i chilometri"); return; }
    setBusy(true);
    try {
      await api.post(`/equipment/${eq.id}/lettura`, {
        date: data,
        ore: ore === "" ? null : parseInt(ore, 10),
        km: km === "" ? null : parseInt(km, 10),
        note: note || null,
      });
      toast.success("Lettura registrata");
      chiudi();
      onSaved?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore nel salvataggio");
    } finally { setBusy(false); }
  };

  return (<>
    <Button variant="outline" size="sm" onClick={() => setAperto(true)}
            className="flex-1 lg:flex-none" data-testid="lettura-contatore-btn">
      <Gauge className="w-4 h-4 mr-2" />Contatore
    </Button>

    {aperto && (
      <Dialog open onOpenChange={chiudi}>
        <DialogContent>
          <DialogHeader><DialogTitle>Lettura contatore — {eq.identifier}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <p className="text-xs text-slate-500">
              Leggi il valore sulla macchina e scrivilo qui. Serve a calcolare quanto
              costa per ora e per chilometro.
            </p>

            {(eq.ore_ultima_lettura != null || eq.km_ultima_lettura != null) && (
              <div className="text-xs bg-slate-50 border border-slate-200 rounded p-2">
                Ultima lettura registrata:{" "}
                {eq.ore_ultima_lettura != null && <b>{eq.ore_ultima_lettura} ore</b>}
                {eq.ore_ultima_lettura != null && eq.km_ultima_lettura != null && " · "}
                {eq.km_ultima_lettura != null && <b>{eq.km_ultima_lettura} km</b>}
              </div>
            )}

            <div><Label>Data</Label>
              <Input type="date" value={data} onChange={(e) => setData(e.target.value)} /></div>

            <div className="grid grid-cols-2 gap-3">
              <div><Label>Ore al contaore</Label>
                <Input type="number" inputMode="numeric" value={ore}
                       onChange={(e) => setOre(e.target.value)} /></div>
              <div><Label>Chilometri</Label>
                <Input type="number" inputMode="numeric" value={km}
                       onChange={(e) => setKm(e.target.value)} /></div>
            </div>

            <div><Label>Note (facoltative)</Label>
              <Input value={note} onChange={(e) => setNote(e.target.value)} /></div>

            <DialogFooter>
              <Button variant="outline" onClick={chiudi}>Annulla</Button>
              <Button onClick={salva} disabled={busy}
                      className="bg-orange-500 hover:bg-orange-600 text-white">
                {busy ? "Salvataggio..." : "Registra"}
              </Button>
            </DialogFooter>
          </div>
        </DialogContent>
      </Dialog>
    )}
  </>);
}
